import { Navigate, useLocation } from "react-router-dom"

const Protected = ({ children }) => {

  let checkAuth = sessionStorage.getItem('authed');

  let location = useLocation();

  if (checkAuth=='false'||checkAuth==null) {
    return <Navigate to='/' state={{ from: location }} replace />
  }

  return children

};

export default Protected;
